// extracted by mini-css-extract-plugin
module.exports = {"small":"HypeyIcon_small__3lM_O","medium":"HypeyIcon_medium__3543l","large":"HypeyIcon_large__ryNOG"};